module.exports = __webpack_public_path__ + "static/media/Backstage-b.f9279547.webp";